import api from './client'
import type { SentenceAnalysis } from '@/types/sentence'

export function analyzeSentence(sentence: string, language?: string) {
  return api.post<{ data: SentenceAnalysis }>('/sentence_analysis', { sentence, language })
}
